import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutOpportunityList extends Layout {
    layoutheaderOpportunityList: LayoutHeader;
    sourceOpportunity: DataSource;
    tableOpportunities: Table;
}
